/**
 * model-compare.js — WS-PT-03
 * Model Compare interaction for VM pages.
 *
 * Reads window.ptModelSpecs (pre-loaded by model-compare.liquid Liquid render).
 * On dropdown change, updates the comparison column header and all data cells.
 * No page reload — all spec data is embedded in the page.
 *
 * PC-06 resolution: uses pre-loaded window.ptModelSpecs — no Storefront API required.
 */
(function () {
  'use strict';

  var specs = window.ptModelSpecs || {};

  /**
   * Update comparison column cells.
   * @param {string} modelName - The selected model title, or empty string to reset.
   * @param {number} colNum - Column index (currently always 1).
   */
  function updateCompareColumn(modelName, colNum) {
    var colCells = document.querySelectorAll('.pt-compare-col-' + colNum);
    var header = document.getElementById('pt-col-' + colNum);

    if (!modelName || !specs[modelName]) {
      if (header) header.textContent = '—'; // em dash
      colCells.forEach(function (cell) {
        cell.textContent = '—';
      });
      return;
    }

    var modelSpecs = specs[modelName];
    if (header) header.textContent = modelName;

    colCells.forEach(function (cell) {
      var key = cell.getAttribute('data-key');
      var unit = cell.getAttribute('data-unit') || '';
      var val = modelSpecs[key];

      if (val === undefined || val === null) {
        cell.textContent = '—';
      } else if (key === 'hepa_available') {
        cell.textContent = val ? 'Yes' : 'No';
      } else {
        cell.textContent = val + (unit ? ' ' + unit : '');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var select = document.getElementById('pt-compare-model-1');
    if (!select) return;

    select.addEventListener('change', function () {
      updateCompareColumn(this.value, 1);
    });
  });
})();
